module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.changePassword
    }
  }, [_c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "3"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "6"
    }
  }, [_c('img', {
    attrs: {
      "title": _vm.$t('LNG_TITLE', this.lang),
      "alt": _vm.$t('LNG_TITLE', this.lang),
      "width": "200px",
      "src": require("../assets/img/logo.jpg")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('LNG_CHANGE_PASSWORD', _vm.lang)))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('LNG_NEW_PASSWORD', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('LNG_NEW_PASSWORD_CONFIRM', _vm.lang),
      "required": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.newPasswordConfirm),
      callback: function($$v) {
        _vm.newPasswordConfirm = $$v
      },
      expression: "newPasswordConfirm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "2",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "5",
      "lg": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CONFIRM', _vm.lang)))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "5",
      "lg": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "danger",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePasswordCancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CANCEL', _vm.lang)))])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(this.errorMessage))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ae45c0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = 874
// module chunks = 1